export enum AppsAndGamesTraySubtype {
  InstalledApps = 'Installed apps',
  RecommendedApps = 'Recommended apps',
}
